const CS571OnPremConfig = {
    BADGERAUTH_API: "https://cs571api.cs.wisc.edu/rest",
    BADGERAUTH_UI_CENTER: "https://cs571api.cs.wisc.edu/ui/auth",
    CAPTCHA: "6Ld4TtgpAAAAAEVkreEtCPjNYakBLw-NuuOM2lOq",
    BASE: "/ui",
    IS_ON_PREM: true
}

export default CS571OnPremConfig;